<!--modale-->
<div class="modal fade alert-modal" tabindex="-1" role="dialog" id="message-modal">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div *ngIf="confirmPayload && !confirmationLoading" class="modal-content rounded rounded-900 shadow-modal">
      <div class="modal-header">
        <!-- <button type="button" class="close" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> -->
        <ng-container [ngSwitch]="message.type">
          <svg *ngSwitchCase="MessageType.WARNING_MESSAGE" class="icon warning">
            <use xlink:href="assets/svg/sprite.svg#it-error"></use>
          </svg>
          <!--          <svg *ngSwitchCase="MessageType.CONFIRM_MESSAGE" class="icon success">-->
          <!--            <use xlink:href="assets/svg/sprite.svg#it-check-circle"></use>-->
          <!--          </svg>-->
          <!--          <svg *ngSwitchCase="MessageType.INFO_MESSAGE" class="icon info">-->
          <!--            <use xlink:href="assets/svg/sprite.svg#it-info-circle"></use>-->
          <!--          </svg>-->
          <!--          <svg *ngSwitchCase="MessageType.ERROR_MANAGED" class="icon error">-->
          <!--            <use xlink:href="assets/svg/sprite.svg#it-close-circle"></use>-->
          <!--          </svg>-->
          <!--          <svg *ngSwitchDefault class="icon icon-primary">-->
          <!--            <use xlink:href="assets/svg/sprite.svg#it-close-circle"></use>-->
          <!--          </svg>-->
        </ng-container>
        <h5 class="modal-title"
            id="message-modal-title">{{(message.title || getDefaultTitle()) | translate}}</h5>
      </div>
      <div class="modal-body">
        <div class="container-fluid pb-3">
          {{message.message|translate}}
        </div>
        <!--        in caso di errore della callback-->
        <div class="row" *ngIf="callbackError">
          L'operazione è andata in errore
        </div>

        <app-spinner *ngIf="confirmationLoading"></app-spinner>

      </div>
      <div class="modal-footer">
        <button *ngIf="confirmPayload" type="button" class="btn btn-primary"
                (click)="onConfirmAction(confirmPayload)">{{'BUTTON.CONFIRM'|translate}}</button>
        <button type="button" class="btn btn-outline-primary" (click)="close()">{{'BUTTON.CLOSE'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<!--toast-->
<div class="toast bg-primary" role="alert" aria-live="assertive" aria-atomic="true"
     [ngStyle]="{'z-index': message ? 1051 : 0}"
     [ngClass]="{'toast-info':message?.type === MessageType.INFO_MESSAGE,'toast-warning':message?.type === MessageType.WARNING_MESSAGE,'toast-error':message?.type === MessageType.ERROR_MANAGED,'toast-success':message?.type === MessageType.CONFIRM_MESSAGE}">
  <ng-container *ngIf="message && !confirmPayload">
    <!--        <div class="toast-header">-->
    <!--          <strong class="ml-1 mr-auto">{{(message.title || getDefaultTitle()) | translate}}</strong>-->
    <!--          <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">-->
    <!--            <span aria-hidden="true">&times;</span>-->
    <!--          </button>-->
    <!--        </div>-->
    <div class="toast-body">
      <!--      <strong-->
      <!--        class="row m-0 p-0 white-color font-weight-bolder">{{(message.title || getDefaultTitle()) | translate}}</strong>-->
      <div class="white-color row m-0 p-0">
        <div class="flex-shrink-1">
          <ng-container [ngSwitch]="message.type">
            <img class="pr-2 toast-info" *ngSwitchCase="MessageType.INFO_MESSAGE"
                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII="
                 alt="Info message">
            <img class="pr-2 toast-error" *ngSwitchCase="MessageType.ERROR_MANAGED"
                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII="
                 alt="Error message">
            <img class="pr-2 toast-warning" *ngSwitchCase="MessageType.WARNING_MESSAGE"
                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII="
                 alt="Warning message">
            <img class="pr-2 toast-success" *ngSwitchCase="MessageType.CONFIRM_MESSAGE"
                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII="
                 alt="Success message">
          </ng-container>
        </div>

        <div class="col">{{message.message|translate}}</div>
      </div>
      <div class="row error-list" *ngIf="message['errorList']">
        <ul>
          <li
            *ngFor="let error of message['errorList']">{{error.message || 'ERROR.CODE_' + error.code|translate}}</li>
        </ul>
      </div>
      <div class="row validation-error-list" *ngIf="message['validationErrors']">
        <ul>
          <li
            *ngFor="let error of message['validationErrors']">{{error.message || 'ERROR.CODE_' + error.code|translate}}</li>
        </ul>
      </div>
    </div>
    <div class="progress"
         [ngClass]="{'bg-success':message.type === MessageType.CONFIRM_MESSAGE,'bg-warning':message.type === MessageType.WARNING_MESSAGE,'bg-danger':message.type === MessageType.ERROR_MANAGED}">
      <div class="progress-bar"
           [ngClass]="{'bg-success-dark':message.type === MessageType.CONFIRM_MESSAGE,'bg-info-dark':message.type === MessageType.INFO_MESSAGE,'bg-warning-dark':message.type === MessageType.WARNING_MESSAGE,'bg-danger-dark':message.type === MessageType.ERROR_MANAGED}"
           role="progressbar" aria-valuenow="100" aria-valuemin="0"
           aria-valuemax="100" style="max-width: 100%">
      </div>
    </div>
  </ng-container>
</div>
